// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p[data-v-69145dc7] {\n  margin-bottom: 0px;\n}\n.panel-body[data-v-69145dc7] {\n  padding: 0px;\n}\n.panel-heading[data-v-69145dc7] {\n  border-bottom: 0px;\n}\n.panel-footer[data-v-69145dc7] {\n  border-top: 0px;\n}", ""]);
// Exports
module.exports = exports;
